// Awards & recognition — single source of truth.
// Order: most recent / most significant first. Set `featured: true` for hero placement.

export const awards = [
  {
    slug: "times-ecopreneur-2026",
    awardedBy: "Times Internet",
    awardName: "Ecopreneur Awards 2026",
    category: "Ecotech & Climate Innovation · Individual",
    recipient: "Rohit Khattar",
    recipientRole: "Founder & CEO · United Platform Solutions Global™",
    project: "AOCEMS — Africa Online Continuous Emission Monitoring System",
    year: "2026",
    citation:
      "Honouring innovations that are creating meaningful impact in climate action and environmental sustainability.",
    publisher: "The Times of India",
    hashtag: "#EcopreneurAwards2026",
    images: [
      {
        src: "/imagery/awards/times-ecopreneur-2026-handover.jpeg",
        caption: "Award handover · Times Internet Ecopreneur Awards 2026",
      },
      {
        src: "/imagery/awards/times-ecopreneur-2026-stage.jpeg",
        caption: "On stage · Ecopreneur Awards 2026",
      },
      {
        src: "/imagery/awards/times-ecopreneur-2026.jpeg",
        caption: "Ceremony · Ecopreneur Awards 2026",
      },
      {
        src: "/imagery/awards/times-ecopreneur-2026-portrait.jpeg",
        caption: "Rohit Khattar · Founder & CEO, AOCEMS",
      },
      {
        src: "/imagery/awards/times-ecopreneur-2026-announcement.jpeg",
        caption: "Selection notice · Times Internet jury",
      },
    ],
    imageAlt: "Rohit Khattar receiving the Times Internet Ecopreneur Award 2026 on stage",
    accent: "from-emerald-400 via-brand to-teal-400",
    featured: true,
  },
  {
    slug: "sustainability-innovation-leader-2026",
    awardedBy: "Insights Success Media",
    awardName: "Sustainability & Environmental Innovation Leader 2026",
    category: "Global Excellence & Leadership Awards Africa 2026",
    recipient: "Rohit Khattar",
    recipientRole: "Founder & CEO · United Platform Solutions Global™",
    project: "AOCEMS — Africa Online Continuous Emission Monitoring System",
    year: "2026",
    location: "Cape Town, South Africa",
    citation:
      "Recognising a reflection of the collective efforts of our teams, partners, environmental agencies, and stakeholders across Africa working to advance sustainability through technology and innovation — with AOCEMS delivering real-time environmental intelligence, emissions monitoring, and data-driven decision-making for a cleaner, more sustainable future.",
    publisher: "Global Excellence & Leadership Awards Africa 2026 · Cape Town",
    hashtag: "",
    images: [
      {
        src: "/imagery/awards/sustainability-2026-trophy-onstage.jpeg",
        caption: "On stage · Award handover · Cape Town",
      },
      {
        src: "/imagery/awards/sustainability-2026-trophy.jpeg",
        caption: "The trophy · DoubleTree by Hilton, Cape Town · 6 June 2026",
      },
      {
        src: "/imagery/awards/sustainability-2026-event-banner.jpeg",
        caption: "Global Excellence & Leadership Awards Africa 2026",
      },
      {
        src: "/imagery/awards/sustainability-2026-panel.jpeg",
        caption: "Panel discussions · Insights Excellence Awards",
      },
    ],
    imageAlt: "Sustainability & Environmental Innovation Leader 2026 trophy — Rohit Khattar (AOCEMS)",
    accent: "from-amber-400 via-brand to-emerald-500",
    featured: true,
  },
];

export const awardsCount = awards.length;
